module.exports = __webpack_public_path__ + "static/media/loading-white.13444a37.svg";